module.exports = __webpack_public_path__ + "img/Propoxyphene (PPX).4425a11d.png";